import React from "react"
import {Drone, DroneComponent, DroneTab} from "@murphy-frontend/common/api/DroneEvents/types"
import {FunctionComponent} from "react"
import CompleteButton from "./BlockComponents/CompleteButton"
import CheckList from "./BlockFields/CheckList"
import TitleBlock from "./BlockFields/TitleBlock"
import AccordionBlock from "./BlockFields/AccordionBlock"
import TextBlock from "./BlockFields/TextBlock"

interface StartedEventFlowTabProps {
	tab: DroneTab
}

const StartedEventFlowTab: FunctionComponent<StartedEventFlowTabProps> = ({tab}) => {
	return <div className='event-tab-container'>{getTabComponents(tab.Components)}</div>
}

function getTabComponents(components: Readonly<DroneComponent[]>) {
	return components.map((component, index) => {
		return (
			<div className='event-tab-section' key={`${component.Title}-${index}`}>
				{getComponentBasedOnType(component)}
			</div>
		)
	})
}

function getComponentBasedOnType(component: DroneComponent) {
	const {__Type: __type} = component

	switch (__type) {
		case "Title":
			return <TitleBlock eventFlowBlock={component} />
		case "Text":
			return <TextBlock eventFlowBlock={component} />
		case "Accordion":
			return <AccordionBlock accordionComponent={component} />
		case "CheckList":
			return <CheckList checkList={component} />
		case "CompletedButton":
			return <CompleteButton eventFlowBlock={component} />
		default:
			return <></>
	}
}

export default StartedEventFlowTab
